<template>
  <div class="property-input">
    <label class="property-label">
      {{ property.text ? property.text : property.name }}
      <Tooltip v-if="property.tooltip" :text="property.tooltip" />
    </label>
    <input 
      type="number" 
      :value="parseInt(element)" 
      @input="updateProperty({element: container, property: property, value: parseInt($event.target.value)})"
      class="property-number-input"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import Tooltip from "../Tooltip.vue"

export default {
  name: 'NumberInput',
  props: {
    property: {
      type: Object,
      required: true
    },
    element: {
      type: [Number, String],
      required: true
    },
    container: {
      type: Object,
      required: true
    }
  },
  components: {
    Tooltip
  },
  computed: {
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'updateProperty': actions.UPDATE_PROPERTY
    }),
  }
}
</script>

<style scoped>
.property-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
}

.property-label {
  font-size: 1rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1);
  color: #e5e7eb;
  display: flex;
  justify-content: space-between;
}

.property-number-input {
  padding: inherit;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  color: #e5e7eb;
  transition: all 0.2s ease;
}

.property-number-input:focus {
  outline: none;
  border-color: #3b82f6;
  background-color: rgba(255, 255, 255, 0.15);
}

.property-number-input:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

/* Masquer les flèches de contrôle pour les inputs number */
.property-number-input::-webkit-outer-spin-button,
.property-number-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.property-number-input[type=number] {
  -moz-appearance: textfield;
}
</style>
